export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: "哈哈影院是完全免费的吗？",
    answer: "是的，哈哈影院提供的所有影视内容均为免费在线观看，您无需支付任何费用即可享受高清流畅的观影体验。我们致力于让每一位用户都能轻松获取优质的影视资源。",
  },
  {
    question: "为什么我在哈哈影院观看视频时不会卡顿缓冲？",
    answer: "哈哈影院采用了先进的CDN加速技术和多线路智能调度系统，确保视频播放流畅不卡顿。我们与多家顶级云服务商合作，在全国范围内部署了数千个加速节点，无论您身在何处都能获得流畅的观影体验。",
  },
  {
    question: "哈哈影院支持哪些设备观看？",
    answer: "哈哈影院全面支持PC端、平板、手机等多种设备。您可以通过浏览器直接访问我们的网站，无需下载任何App即可享受高清观影体验。我们的网站采用响应式设计，能够自动适配不同屏幕尺寸。",
  },
  {
    question: "哈哈影院的影视资源更新速度快吗？",
    answer: "哈哈影院拥有专业的资源更新团队，热门电影和电视剧通常在上线后24小时内即可在平台观看。对于热播剧集，我们会在每集播出后及时更新，确保您不错过任何精彩内容。",
  },
  {
    question: "哈哈影院提供哪些类型的影视内容？",
    answer: "哈哈影院涵盖电影、电视剧、动漫、综艺等丰富的影视类型。无论是好莱坞大片、国产热门剧集、日本动漫还是韩国综艺，您都可以在这里找到。我们持续扩充内容库，满足不同用户的观影偏好。",
  },
  {
    question: "如何在哈哈影院搜索我想看的影片？",
    answer: "您可以通过首页顶部的搜索框输入影片名称进行搜索，也可以通过分类页面按电影、电视剧、动漫、综艺等不同类别浏览内容。此外，首页的「热门推荐」和「最新上线」版块也能帮助您快速发现热门内容。",
  },
];